<template>
    <div class="content_div">
        <el-card>
            <!--商品-->
            <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                <el-form-item label="商品名称" clearable>
                    <el-input class="input_class" v-model="query.title" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button v-if="currentLoginUserType!==1" type="success" @click="btnInsert(null,0)">新增</el-button>
            </el-form>

            <el-table
                :data="dataList"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="title" label="商品名称"/>
                <el-table-column prop="introduction" label="商品介绍"/>
                <el-table-column prop="remark" label="备注"/>
                <el-table-column prop="createUserName" label="创建人"/>
                <el-table-column prop="createTime" label="创建时间"/>
                <el-table-column align="center" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isCheckFlag" size="small" type="success" @click="btnCheck(scope.row.id,scope.row.title)">选择
                        </el-button>
                        <el-button v-if="scope.row.isUpdateFlag" size="small" type="info" @click="btnInsert(scope.row,2)">修改</el-button>
                        <el-button v-if="scope.row.isDeleteFlag" size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :total="total">
            </el-pagination>

        </el-card>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close" width="50%">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-form-item label="商品名称" prop="title">
                    <el-input maxLength="20" v-model="data.title" maxlength="20" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品介绍" prop="introduction">
                    <el-input maxlength="50" v-model="data.introduction" auto-complete="off" placeholder="请输入商品介绍"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="data.remark" auto-complete="off" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="data.sort" controls-position="right" :min="0"/>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="checkDialogFlag" @close="close2" width="50%">
            <el-form label-width="120px" :model="checkData" ref="checkData" :rules="checkRules">
                <!--商品名称-->
                <el-form-item label="商品名称">
                    <el-input disabled v-model="checkData.title" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="选择店铺" prop="shopId">
                    <el-select v-model="checkData.shopId" placeholder="请选择店铺">
                        <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品价格" prop="price">
                    <el-input-number maxLength="3" v-model="checkData.price" :min="1" :max="100" label="请输入商品价格"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close2'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm2('checkData')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import global from "@/api/global";
import {reqDeleteCustomizeGoodsById, reqInsertCustomizeGoods, reqListCustomizeGoods, reqUpdateCustomizeGoods} from "@/api/core/CustomizeGoods";
import user from "@/store/modules/user";
import {reqListShop} from "@/api/core/Shop";
import {reqCheckCustomizeGoods} from "@/api/core/Goods";

export default {
    name: "User",
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            this.dataList = [];
            let data = await reqListCustomizeGoods(this.query);
            this.dataList = data.records;
            this.total = data.total;
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {};
            } else if (type === 1) {
                this.data = {};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async close() {
            this.isShowDialogFlag = false;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    let result = !this.data.id ? await reqInsertCustomizeGoods(this.data) : await reqUpdateCustomizeGoods(this.data);
                    this.$message.success("操作成功");
                    await this.close();
                    await this.load();
                }
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteCustomizeGoodsById({id: id});
                this.$message.success("操作成功");
                this.query.currentPage = 1
                await this.load();
            });
        },
        async btnCheck(id, title) {
            //加载该商家的店铺列表
            this.shopList = [];
            let data = await reqListShop();
            this.shopList = data;
            this.checkData.customizeGoodsId = id;
            this.checkData.title = title;
            this.checkDialogFlag = true;
        },
        close2() {
            this.checkDialogFlag = false;
        },
        async submitForm2(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    let result = await reqCheckCustomizeGoods(this.checkData);
                    this.$message.success("操作成功");
                    await this.close2();
                    await this.load();
                }
            })
        },
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {
                currentPage: 1,
                pageSize: 10,
            },
            isShowDialogFlag: false,
            filePre: global.preview_path_url,
            data: {
                id: null,
            },
            rules: {
                title: [
                    {required: true, message: '请输入标题', trigger: 'blur'},
                ],
                introduction: [
                    {required: true, message: '请输入商品介绍', trigger: 'blur'},
                ],
                sort: [
                    {required: true, message: '请输入排序', trigger: 'blur'},
                ]
            },
            currentLoginUserType: user.state.type,
            //选择菜品
            checkDialogFlag: false,
            checkData: {
                customizeGoodsId: null,
                title: null,
                shopId: null,
                price: null,
            },
            shopList: [],
            checkRules: {
                shopId: [
                    {required: true, message: '请选择店铺', trigger: 'blur'},
                ],
                price: [
                    {required: true, message: '请输入价格', trigger: 'blur'},
                ]
            }
        }
    },
}
</script>
